// Form validation for event trigger form

import { plaintextValidator } from '../fields';
import ruleBuilder from '../utils/RuleBuilder';

// TODO: Find mandatory fields in schema and update fields

const config = { mandatory: true };

export default {
  name: plaintextValidator(config),
  event: plaintextValidator(config),
  ruleCondition: { presence: { allowEmpty: false } },
  ...ruleBuilder('ruleCondition.operands')
};
